module.exports = __webpack_public_path__ + "img/google.aa24572b.png";